export const Link_url = {
    //统一
    // urll: 'http://school.cz.365mooc.cn/',
    url1: 'http://www.zhxy.czvtc.edu.cn',

    //在线报名  招生报名网域名
    jumpUrl: 'http://zsg.zhxy.czvtc.edu.cn',

    //在线问答
    quertion: 'http://wpa.qq.com/msgrd?v=3&uin=2621599119&site=qq&menu=yes',
    //接口
    // url: 'http://api.cz.365mooc.cn/',
    url : 'http://api.zhxy.czvtc.edu.cn/',
    //jump
    jump: 'http://jyzs.czgz.cn:8100/zsw/2018flks/czzyjsxy_flks.html',

    //底部
    fooone: 'http://www.miitbeian.gov.cn/state/outPortal/loginPortal.action;jsessionid=jUpKToukN2lqWTcin0MgCMGuZHYEJXUhsSn77b7HWXhbfjbAPhNE!-2113647171',

    footwo: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34170002000066',

    foothree: 'http://bszs.conac.cn/sitename?method=show&id=0973505E8DDD6365E053022819AC8FD2'
}


// WEBPACK FOOTER //
// ./src/api/config.js